
<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.create')"
              :icon="'mdi-content-save'"
              :color="'quaternary'"
              :disabled="!creatable"
              :outlined="false"
              :textbtn="textbtn"
              :large="large"
              :small="small"
              @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "CreateJobBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      if (this.creatable) {
        this.$store.dispatch("JobHub/JobParentjob/createJob").then((response) => {
          this.$store.dispatch("BackgroundUpdater/Checker", "StatusMap");
          this.$router.replace({ name: "ViewJob", params: { filter: "my", jobId: response.Id } });
        });
      }
    },
  },

  computed: {
    creatable() {
      return this.$store.getters["JobHub/SaveableJob"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
